import { render, staticRenderFns } from "./student-achievement-result.vue?vue&type=template&id=300eb149&"
import script from "./student-achievement-result.vue?vue&type=script&lang=js&"
export * from "./student-achievement-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports